let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("F3QUg")).then(() => parcelRequire('30ibK'));